import styled, { css } from 'styled-components';

const inputSize = (props: any) => {
  let width = '16px';
  let height = '16px';

  switch (props.size) {
    case 'large':
      width = '26px';
      height = '26px';
      break;
    default:
  }

  return css`
    width: ${width};
    height: ${height};
  `;
};

export const Input = styled.input`
  margin: 0;
  position: absolute;
  ${inputSize};
  opacity: 0;

  &:checked + span {
    border-color: ${props => props.theme.colors.primary};
    background-color: ${props => props.theme.colors.primary};
    &:before {
      color: white;
      content: "\f00c";
    }
  }
`;

const checkboxSize = (props: any) => {
  let width = '14px';
  let height = '14px';
  let fontSize = '10px';

  switch (props.size) {
    case 'large':
      width = '24px';
      height = '24px';
      fontSize = '12px';
      break;
    default:
  }

  return css`
    width: ${width};
    height: ${height};
    font-size: ${fontSize};
    line-height: ${height};
    border-radius: 3px;
  `;
};

export const Checkbox = styled.div`
  ${props => props.isBlink && `
    animation: blinker 1s linear;
  `}

  span {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-weight: 900;
    font-family: "Font Awesome 5 Free";
    font-style: normal;
    font-variant: normal;
    text-align: center;
    text-rendering: auto;
    display: block;
    box-sizing: border-box;
    border: 1px solid transparent;
    border-color: ${props => (props.disabled ? '#d2d2d2' : '#767676')};
    ${checkboxSize};
  }

  & + label {
    user-select: none;
  }

  @keyframes blinker {
      25% {
          opacity: 0;
      }
      50% {
          opacity: 1;
      }
      75% {
          opacity: 0;
      }
  }
`;
